<template>
  <div id="sharelive">
    <van-row>
      <van-col span="24" class="sharelive_play">
        <div id="mse" class="sharelive_play_video">
        </div>
        <van-col span="24" class="sharelive_play_end" v-if="is_live_end">
          <van-col offset="3" span="18" class="sharelive_play_end_name"> 直播已结束 </van-col>
          <van-col offset="3" span="18" class="sharelive_play_end_sum"> 109人看过 </van-col>
          <van-col offset="3" span="18" class="sharelive_play_end_follow"> 关注后就不会错过下一次直播啦~ </van-col>
        </van-col>
        <van-col span="24" class="sharelive_play_host">
          <van-col offset="1" span="4" class="sharelive_play_host_img">
            <van-image
              round
              width="3em"
              height="3em"
              :src="user.head_image"
            />
          </van-col>
          <van-col span="14" class="sharelive_play_host_center">
            <van-col span="24" class="sharelive_play_host_center_name">
              {{ user.nick_name }}
            </van-col>
            <van-col span="24" class="sharelive_play_host_center_id">
              ID：{{ user.id }}
            </van-col>
          </van-col>
          <van-col span="4" class="sharelive_play_host_center_download">下 载 </van-col>
        </van-col>
      </van-col>
      <!-- 更多直播 -->
      <van-col span="24" class="sharelive_type">
        <van-col span="24" class="sharelive_type_title">
          <van-col offset="2" span="10" :class="sharelive_type_i == 1 ? 'sharelive_type_title_name sharelive_type_title_bor' : 'sharelive_type_title_name'">
            热门布谷鸟直播系统
          </van-col>
          <van-col span="10" class="sharelive_type_title_name" :class="sharelive_type_i != 1 ? 'sharelive_type_title_name sharelive_type_title_bor' : 'sharelive_type_title_name'">
            精彩回放
          </van-col>
        </van-col>
        <van-col span="24" class="sharelive_type_list">
          <van-col span="12" v-for="(v,i) in list" :key="i">
            <van-col offset="2" span="20" class="sharelive_type_list_bg">
              <van-col span="24" class="sharelive_type_list_bg_img">
                <img :src="v.live_image" class="sharelive_type_list_bg_img1"/>
                <div class="sharelive_type_list_bg_img_sum">
                  <img src="../assets/img/play_combination_Icon.png" class="sharelive_type_list_bg_img_icon"/>
                  {{ v.virtual_watch_number }}
                </div>
              </van-col>
              <van-col span="24" class="sharelive_type_list_bg_name">
                {{ v.nick_name }}
              </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="sharelive_bottom">
        <van-col offset="1" span="4" class="sharelive_bottom_img">
          <van-image
            width="3em"
            height="3em"
            :src="user.head_image"
          />
        </van-col>
        <van-col span="14" class="sharelive_bottom_center">
          <van-col span="24" class="sharelive_bottom_center_name">
            {{ user.nick_name }}
          </van-col>
          <van-col span="24" class="sharelive_bottom_center_id">
            ID：{{ user.id }}
          </van-col>
        </van-col>
        <van-col span="4" class="sharelive_play_host_center_download">下 载 </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import { Dialog } from 'vant'
  import Player from 'xgplayer';
  export default {
    data() {
      return {
        Player: null,
        configMp4: {
          id: 'mse',
          url:'//sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-720p.mp4',
          poster: "//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg",
          fitVideoSize: 'auto',
          'x5-video-player-type': 'h5',
          playsinline: false,
          'x5-video-player-fullscreen': false,
          autoplay: false,
          controls: false,
          cssFullscreen: true,
          ignores: ['replay']
        },
        is_live_end: false, // 直播是否结束
        user:{
          id: '125025',
          nick_name: '布谷鸟名称',
          head_image: '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
        },
        sharelive_type_i: 0,
        list:[
          {
            'id': '12356',
            'nick_name': '布谷鸟名称',
            'head_image': '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
            'live_image': '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
            'virtual_watch_number': '1000',
            'play_url': '//sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-720p.mp4',
            'live_in': 1
          },
          {
            'id': '12356',
            'nick_name': '布谷鸟名称',
            'head_image': '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
            'live_image': '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
            'virtual_watch_number': '1000',
            'play_url': '//sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-720p.mp4',
            'live_in': 1
          },
          {
            'id': '12356',
            'nick_name': '布谷鸟名称',
            'head_image': '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
            'live_image': '//s2.pstatp.com/cdn/expire-1-M/byted-player-videos/1.0.0/poster.jpg',
            'virtual_watch_number': '1000',
            'play_url': '//sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-720p.mp4',
            'live_in': 1
          },
        ],
      }
    },
    mounted() {
      this.convert();
    },
    created: function() {
      document.title = this.$t('title.shartlive')
    },
    components: {
      [Dialog.name]: Dialog
    },
    methods: {
      convert: function() {
        console.log('ddddddddd')
        let player=new Player(this.configMp4);
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shareLive.vue